import { useIntl } from 'react-intl';
import { IconInfoCircle } from '@rossum/ui/icons/tabler';
import { SvgIcon, Tooltip, Typography } from '@rossum/ui/material';
import { docsLinks } from '../../../constants/values';
import { link } from '../../../lib/formaterValues';
import { GroupRole } from '../../../types/group';

type RoleTooltipProps = {
  roles: Array<GroupRole>;
};

export const RoleTooltip = ({ roles }: RoleTooltipProps) => {
  const intl = useIntl();

  return (
    <Tooltip
      placement="top"
      slotProps={{
        tooltip: {
          sx: {
            maxWidth: 750,
            textAlign: 'left',
          },
        },
      }}
      title={
        <>
          {roles.map(role => (
            <div key={role}>
              <Typography variant="body2" component="span">
                <Typography variant="body2" fontWeight={600} component="span">
                  {intl.formatMessage({
                    id: `containers.settings.users.roles.${role}`,
                  })}
                </Typography>
                {` - `}
                {intl.formatMessage(
                  {
                    id: `containers.settings.users.roles.${role}.description`,
                  },
                  {
                    link:
                      role === 'organization_group_admin' &&
                      link(docsLinks.userRole),
                  }
                )}
              </Typography>
            </div>
          ))}
        </>
      }
    >
      <SvgIcon fontSize="medium">
        <IconInfoCircle />
      </SvgIcon>
    </Tooltip>
  );
};
